import { InputType } from 'config'

export const defaultInputs = (): Record<string, InputType> => {
  return {
    achFlag: {
      inputType: 'select',
      options: ['Y', 'N'],
      title: 'ACH Flag',
      hasDefaultOption: true,
    },
    accountType: {
      inputType: 'select',
      options: ['Checking', 'Savings'],
      title: 'ACH Account Type',
      hasDefaultOption: true,
    },
    accountNo: {
      inputType: 'text',
      type: 'number',
      title: 'Account #',
    },
    accountRoutingNo: {
      inputType: 'text',
      type: 'routingNo',
      title: 'Account Routing #',
    },
    accountFinancialInsName: {
      inputType: 'text',
      title: 'Account Financial Institution Name',
    },
    accountName: {
      inputType: 'text',
      title: 'Name of Account',
    },
    dealyDays: {
      inputType: 'text',
      type: 'thousandSepNoDecimal',
      title: 'ACH Delay Days',
    },
    nextPaymentDate: {
      inputType: 'text',
      type: 'date',
      title: 'Next Payment Date',
    },
    firstPaymentDate: {
      inputType: 'text',
      type: 'date',
      title: 'First Payment Date',
    },
    paymentFrequency: {
      inputType: 'section',
      title: 'Payment Frequency',
      span: 'full',
    },
  }
}
